// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-l_eE","catalogByServiceItem__title":"c-l_eF"};